export class NewsSearchInitializer {
	public init = () => {
		this.searchButton();

		const dateRangeInput = document.querySelector<HTMLInputElement>('#dateRange');

		dateRangeInput?.addEventListener('change', () => {
			const [dateFrom, dateTo] = dateRangeInput.value.split(' to ');

			const hiddenInputFrom = document.querySelector<HTMLInputElement>('#minimumDate');
			const hiddenInputTo = document.querySelector<HTMLInputElement>('#maximumDate');

			if (hiddenInputFrom == null || hiddenInputTo == null) return;

			hiddenInputFrom.value = dateFrom;
			hiddenInputTo.value = dateTo;
		});

	};

	private searchButton = () => {
		const container = document.querySelector<HTMLDivElement>('.news-search-form');

		if (container == null) return;

		const form = container.querySelector<HTMLFormElement>(' form');
		const searchButton = container.querySelector<HTMLAnchorElement>(' .output .delo-submit');

		searchButton?.addEventListener('click', () => {
			form?.submit();
		});
	};
}
